import { UseGetProductResponse } from "../../types/queries";

import { trackPdcEvent } from "./track-pdc-event";

export const trackFormBackEvent = (
  product: UseGetProductResponse,
  formTrackingId: string,
  step: string | number,
  subStep: string | number
) => {
  trackPdcEvent(product, formTrackingId, "back", step, subStep);
};
